var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xl_login",attrs:{"id":_vm.domId}},[(_vm.inXL)?_c('img',{attrs:{"src":require("assets/pic/login_bg.png")},on:{"click":_vm.showDialog}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }